import { Skeleton } from '@worldcoo/ui/components/skeleton';
import { Header } from './header';
import { Layout } from './layout';

/** Without it these suspending pages fall to the router default and render nothing while loading. */
export function WwwPagePending() {
	return (
		<Layout>
			<Header />
			<div className="mx-auto flex max-w-[1310px] flex-col gap-4 px-4 py-16">
				<Skeleton className="mb-4 h-12 w-80" />
				{Array.from({ length: 8 }).map((_, index) => (
					// oxlint-disable-next-line react/no-array-index-key
					<Skeleton key={index} className={index % 4 === 3 ? 'h-5 w-2/3' : 'h-5 w-full'} />
				))}
			</div>
		</Layout>
	);
}
